import { useEffect, useState } from "react";
import { ProductCard } from "./ProductCard";
import { api } from "../lib/api";

export function ProductRail({ title, eyebrow, params, viewAllHref, viewAllLabel = "View all", testId }) {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let cancelled = false;
        setLoading(true);
        api.get("/products", { params })
            .then(({ data }) => {
                if (!cancelled) setItems(data.items || []);
            })
            .catch(() => !cancelled && setItems([]))
            .finally(() => !cancelled && setLoading(false));
        return () => { cancelled = true; };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [JSON.stringify(params)]);

    if (!loading && items.length === 0) return null;

    return (
        <section className="bg-ivory py-16 lg:py-24" data-testid={testId}>
            <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
                <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-4 mb-10">
                    <div>
                        {eyebrow ? <span className="label-eyebrow">{eyebrow}</span> : null}
                        <h2 className="mt-3 font-display text-3xl sm:text-4xl lg:text-5xl text-inkDark tracking-tight">{title}</h2>
                    </div>
                    {viewAllHref ? (
                        <a href={viewAllHref} className="label-eyebrow text-inkDark hover:text-skyblueDeep transition-colors self-start lg:self-end">
                            {viewAllLabel} &rarr;
                        </a>
                    ) : null}
                </div>
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5 lg:gap-8">
                    {items.slice(0, 8).map((p) => (
                        <ProductCard key={p.id} product={p} />
                    ))}
                </div>
            </div>
        </section>
    );
}
